module.exports = __webpack_public_path__ + "img/192.50db7f4f.jpg";